import { render, staticRenderFns } from "./BasketList.vue?vue&type=template&id=f44679fc&scoped=true&"
import script from "./BasketList.vue?vue&type=script&lang=js&"
export * from "./BasketList.vue?vue&type=script&lang=js&"
import style0 from "./BasketList.vue?vue&type=style&index=0&id=f44679fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f44679fc",
  null
  
)

export default component.exports